import {
  Box,
  Divider,
  FormControlLabel,
  Checkbox,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
  List,
  ListItem,
  ListItemText,
  Button,
  Dialog,
  ListItemAvatar,
  Slide,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useEffect, useState, forwardRef } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ReactComponent as RefundIcon } from "../assets/refund.svg";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import get_token from "../lib/get_token";
import axios from "axios";
import { loginState, configState } from "../lib/State";
import moment from "moment";
import pr from "../lib/pr";
import Loading from "./Loading";
import add_comma from "../lib/add_comma";
import Swal from "sweetalert2";
import get_cid from "../lib/get_cid";
import { ReactComponent as WarningIcon } from "../assets/warning.svg";
import RefundBonus from "./RefundBonus";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const listTheme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: "14px",
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
  },
});

const cellTheme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "6px 0",
          width: "fit-content",
          whiteSpace: "nowrap",
        },
      },
    },
  },
});

function Refund(props) {
  const { login } = props;
  // const [login, setLogin] = useState(loginState);
  // const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const token = get_token();
  const [open, setOpen] = useState(false);
  const [bonus, setBonus] = useState(false);
  const [agree, setAgree] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [reason, setReason] = useState("");
  const [wait, setWait] = useState(false);
  const cid = get_cid();

  const load_data = async () => {
    pr("load_data");
    let result = await axios.post(configState.api + "/gympass/refund_list", {
      token: token,
      cid: cid,
      mcd: login.mcd,
      level: login.level,
    });
    setRows(result.data.rows);
  };
  useEffect(() => {
    load_data();
  }, []);

  const onSubmit = async () => {
    if (coupon === "") {
      Swal.fire("쿠폰을 선택하세요.");
    } else if (reason === "") {
      Swal.fire("사유를 적어주세요.");
    } else {
      let temp = rows;
      temp = temp.filter((el) => el.seq === coupon);
      const restCoupon =
        temp[0].is_seaason === "Y"
          ? 0
          : temp[0].total_count - temp[0].use_count;
      const restDate =
        temp[0].is_seaason === "Y"
          ? 0
          : moment(temp[0].edate).diff(moment(), "days") + 1;
      const commission = temp[0].total_price / 10;
      let use_price = 0;
      const days = moment()
        .startOf("day")
        .diff(moment(temp[0].sdate).startOf("day"), "days", true);
      if (temp[0].is_seaason === "Y") {
        use_price = days * 30000;
      } else {
        use_price =
          (temp[0].origin_price / temp[0].total_count) * temp[0].use_count;
      }
      let left_price = 0;
      if (restCoupon > restDate) {
        left_price =
          (restCoupon - restDate) *
          (temp[0].origin_price / temp[0].total_count);
      } else {
        left_price = 0;
      }
      let final_price =
        temp[0].total_price - commission - use_price - left_price;
      if (final_price < 0) {
        final_price = 0;
      }
      Swal.fire({
        html: `<div style='font-size: 20px; font-weight: bold; margin: 20px 0;'>환불 신청을 하시겠습니까?</div><div>선택한 쿠폰 : 클래스 ${temp[0].total_count}회 이용권</div>`,
        showConfirmButton: true,
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let result = await axios.post(
            configState.api + "/gympass/refund_add",
            {
              token: token,
              cid: cid,
              level: login.level,
              mcd: login.mcd,
              seq: coupon,
              reason: reason,
              cname: temp[0].cname,
              sdate: temp[0].sdate,
              edate: temp[0].edate,
              total_amount: temp[0].total_price,
              total_count: temp[0].total_count,
              use_count: temp[0].is_seaason === "Y" ? days : temp[0].use_count,
              remain_count: restCoupon,
              remain_day: restDate,
              final_amount: final_price,
              use_price: use_price,
              left_price: left_price,
            }
          );

          if (result.data.success === 0) {
            Swal.fire("Error", result.data.msg);
            return;
          } else {
            Swal.fire(
              `환불 신청 완료`,
              "담당자 확인 후 14일 이내로 처리됩니다."
            ).then((result) => {
              if (result.isConfirmed) {
                closeClick();
              }
            });
            // closeClick();
            return;
          }
        }
      });
    }
  };

  const onOpenWait = async () => {
    if (coupon === "") {
      Swal.fire("Error", "쿠폰을 선택하세요");
    }
    if (reason === "") {
      Swal.fire("Error", "사유를 적어주세요");
    }
    if (coupon !== "" && reason !== "") {
      setWait(true);
    }
  };

  const handleChange = (e) => {
    // const { target: { value } } = e;
    // setCoupon(value);
    setCoupon(e.target.value);
  };

  const onConfirmClick = () => {
    setAgree(true);
  };

  const openClick = () => {
    if (rows.length > 0) {
      setWait(true);
    } else {
      setOpen(true);
    }
  };
  const openRefund = () => {
    setOpen(true);
    setCoupon("");
    setReason("");
  };
  const closeClick = () => {
    setOpen(false);
    setWait(false);
  };

  useEffect(() => {
    if (open === true) {
      load_data();
    }
  }, [open]);

  return (
    <Box>
      {/* {loaded ? ( */}
      <>
        <Dialog
          open={wait}
          onClose={() => setWait(false)}
          fullWidth
          maxWidth="md"
        >
          <Box
            sx={{
              width: "100%",
              textAlign: "right",
            }}
          >
            <CloseIcon
              sx={{
                textAlign: "right",
                marginRight: "10px",
                marginTop: "10px",
              }}
              onClick={() => setWait(false)}
            />
          </Box>
          <Box
            sx={{
              padding: "10px 20px 20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <WarningIcon width='60px' /> */}
            <Box
              sx={{
                fontSize: "26px",
                marginBottom: "20px",
                fontWeight: "bold",
              }}
            >
              잠깐!
            </Box>
            <Box
              sx={{
                fontSize: "14px",
              }}
            >
              쿠폰이 만기 되기 전에 결제를 하시면
            </Box>
            <Box sx={{ fontSize: "14px" }}>
              남은 쿠폰을{" "}
              <span style={{ color: "#6cb92d", fontWeight: "bold" }}>
                보너스쿠폰
              </span>
              으로
            </Box>
            <Box
              sx={{
                fontSize: "14px",
              }}
            >
              변경할 수 있습니다.
            </Box>
            <Button
              variant="outlined"
              sx={{
                padding: "5px",
                marginTop: "10px",
                outline: "1px solid black",
                border: "none",
                borderRadius: 0,
                color: "black",
                // fontWeight: 'bold',
                // background: '#6cb92d',
                ":hover": {
                  // background: '#6cb92d',
                  outline: "1px solid black",
                  border: "none",
                },
              }}
              onClick={() => setBonus(true)}
            >
              보너스쿠폰 변경방법
            </Button>
            <Box
              sx={{
                marginTop: "40px",
              }}
            >
              <Button
                variant="contained"
                component={Link}
                to="/buy"
                sx={{
                  background: "#6cb92d",
                  padding: "5px",
                  ":hover": {
                    background: "#6cb92d",
                  },
                }}
              >
                결제 및 보너스쿠폰 생성
              </Button>
              <Button
                variant="contained"
                onClick={openRefund}
                sx={{
                  marginLeft: "25px",
                  background: "gray",
                  padding: "5px",
                  ":hover": {
                    background: "gray",
                  },
                }}
              >
                환불진행
              </Button>
            </Box>
            {/* <Button
                            variant='contained'
                            onClick={() => setWait(false)}
                            sx={{
                                marginTop: '10px',
                                background: 'gray',
                                ':hover': { background: 'gray' },
                            }}
                        >
                            닫기
                        </Button> */}
          </Box>
        </Dialog>
        <Dialog fullScreen open={bonus} onClose={() => setBonus(false)}>
          <Box
            sx={{
              width: "90%",
              textAlign: "left",
              padding: "30px 0 10px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <img
                src="/img/back_button_black.png"
                onClick={() => setBonus(false)}
              />
              <Button
                variant="contained"
                sx={{
                  background: "#6cb92d",
                  borderRadius: 0,
                  boxShadow: "none",
                  padding: "3px 5px",
                  ":hover": {
                    background: "#6cb92d",
                  },
                }}
                component={Link}
                to="/buy"
              >
                보너스쿠폰 변경
              </Button>
            </Box>
            <Box
              sx={{
                margin: "16px 0 0 10px",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              보너스쿠폰 변경방법
            </Box>
          </Box>
          <Divider />
          <RefundBonus />
        </Dialog>
        <Dialog
          fullScreen
          open={open}
          onClose={closeClick}
          TransitionComponent={Transition}
        >
          <Box
            sx={{
              width: "90%",
              textAlign: "left",
              padding: "30px 0 10px 10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <img src="/img/back_button_black.png" onClick={closeClick} />
            <Box
              sx={{
                margin: "16px 0 0 10px",
                fontSize: "22px",
                fontWeight: "bold",
              }}
            >
              환불 신청
            </Box>
          </Box>
          <Divider />
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box sx={{ width: "80%" }}>
              <Box
                sx={{
                  fontWeight: "bold",
                  marginTop: "30px",
                }}
              >
                환불 안내
              </Box>
              <Box
                sx={{
                  fontSize: "14px",
                }}
              >
                <Box
                  sx={{
                    marginTop: "12px",
                  }}
                >
                  환불시에는 결제금액에서 이용한 쿠폰, 잔여일을 초과한 쿠폰,
                  수수료를 각각 제한 금액이 환불 가능합니다.
                </Box>

                <Box
                  sx={{
                    mt: 2,
                  }}
                >
                  <Box>
                    <Box sx={{ fontWeight: "bold" }}>
                      차감금액 I (이용쿠폰차감)
                    </Box>
                    <Box>
                      : 이용한 쿠폰금액의 총 수만큼 차감 (할인전금액기준)
                    </Box>
                    <Box sx={{ fontWeight: "bold", mt: 1 }}>
                      차감금액 II (환불불가쿠폰차감)
                    </Box>
                    <Box>
                      : 남은 쿠폰장수가 잔여일보다 많은 경우, 초과되는 쿠폰의 총
                      수만큼 차감 (할인전금액기준)
                    </Box>
                  </Box>

                  <Box sx={{ mt: 1 }}>
                    <Box sx={{ fontWeight: "bold" }}>수수료</Box>
                    <Box>: 카드결제금액의 10%가 환불 수수료로 적용됩니다.</Box>
                  </Box>
                </Box>

                <Box sx={{ mt: 2 }}>
                  <Box sx={{ fontWeight: "bold" }}>예시(그룹쿠폰기준)</Box>
                  <Box>
                    8회권 120,000원에 결제. 2회 사용 후 유효기간 5일 남은 경우
                  </Box>
                  <Box>① 최초결제금액수수료 10% 차감 : 12,000원</Box>
                  <Box sx={{ fontSize: 12, color: "#6E6E6E" }}>
                    (결제금액에 대한 수수료 10%는 공정거래위원회의 표준약관 7조
                    4항에 의거하여 책정된다.)
                  </Box>
                  <Box>② 이용쿠폰차감 : 1장 30,000원 X 2장 = 60,000원</Box>
                  <Box sx={{ fontSize: 12, color: "#6E6E6E" }}>
                    (소비자가 240,000원의 쿠폰을 50% 할인받아 120,000원에
                    구매하였으므로, 차감할 때는 두써킷센터 이용약관 4조 라항에
                    따라 할인전금액 기준 1회권 30,000원으로 계산한다.)
                  </Box>
                  <Box>
                    ③ 환불불가쿠폰차감 : 환불불가쿠폰 1장 30,000원 X 1장 =
                    30,000원
                  </Box>
                  <Box sx={{ fontSize: 12, color: "#6E6E6E" }}>
                    (1일 1쿠폰만 환불 가능. 남은 쿠폰이 6장이고 쿠폰 유효기간이
                    5일이므로 남은 쿠폰에서 1장이 차감된다.)
                  </Box>
                  <Box sx={{ fontWeight: "bold" }}>
                    최종환불금액 : 결제금액(120,000) - 수수료(12,000) -
                    이용쿠폰차감(60,000) - 환불불가쿠폰차감(30,000) = 18,000원
                  </Box>
                  <Box>
                    정기권의 경우 1일 30,000원과 10%의 취소 수수료가 차감됩니다.
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "80%",
                mt: 2,
              }}
            >
              <Box
                sx={{
                  fontWeight: "bold",
                }}
              >
                쿠폰 선택
              </Box>
              <FormControl
                sx={{
                  width: "100%",
                  marginTop: "16px",
                }}
              >
                {/* <InputLabel sx={{ top: '-8px' }}>쿠폰 선택</InputLabel> */}
                <Select
                  value={coupon}
                  onChange={handleChange}
                  displayEmpty
                  size="small"
                  sx={{
                    width: "100%",
                    fontSize: "14px",
                  }}
                >
                  <MenuItem value="">
                    {rows.length === 0 ? (
                      <em>신청 가능한 쿠폰이 없습니다.</em>
                    ) : (
                      <em>쿠폰을 선택하세요</em>
                    )}
                  </MenuItem>

                  {rows.map((item, index) => {
                    const remain_count =
                      item.total_count + 0 - (item.use_count + 0);
                    let is_available = false;
                    const today = moment().format("YYYY.MM.DD");
                    const sdate = moment(item.sdate).format("YYYY.MM.DD"); // 시작일
                    const edate = moment(item.edate).format("YYYY.MM.DD"); // 만료일
                    // if(enroll_sdate > today) {
                    //   if(today < enroll_edate) {
                    //     if(remain_count>0) {
                    //       is_available = true;
                    //     }
                    //   }
                    //   is_available = false;
                    // }
                    if (remain_count > 0) {
                      if (edate > today) {
                        is_available = true;
                      }
                    }
                    // let is_available = true;
                    const regdate = item.regdate;
                    const cname = item.cname;

                    let gubun = "";
                    if (item.pt_type === "CLASS") {
                      gubun = "클래스";
                    }

                    if (item.pt_type === "PT_MANAGER") {
                      gubun = "점장PT";
                    }

                    if (item.pt_type === "PT_TRAINER") {
                      gubun = "트레이너PT";
                    }

                    return (
                      // <Box
                      //     key={index}
                      // >

                      is_available === true && (
                        <MenuItem key={index} value={item.seq}>
                          {gubun} {item.total_count}회 이용권
                        </MenuItem>
                      )

                      // {is_available === false && (
                      //     <>
                      //     </>
                      // )}
                      // </Box>
                    );
                  })}
                </Select>
              </FormControl>

              {rows.map((item, index) => {
                const remain_count =
                  item.total_count + 0 - (item.use_count + 0);

                const today = moment().format("YYYY.MM.DD");
                const sdate = moment(item.sdate).format("YYYY.MM.DD"); // 시작일
                const edate = moment(item.edate).format("YYYY.MM.DD");

                // let is_available = true;
                const regdate = item.regdate;
                const cname = item.cname;

                // 남은쿠폰
                const restCoupon =
                  item.is_seaason === "Y"
                    ? 0
                    : item.total_count - item.use_count;
                // 남은날짜
                const restDate = moment(item.edate).diff(moment(), "days") + 1;
                // 수수료
                const commission = item.total_price / 10;

                // 이용쿠폰금액
                let use_price = 0;
                const days = moment()
                  .startOf("day")
                  .diff(moment(item.sdate).startOf("day"), "days", true);
                if (item.is_seaason === "Y") {
                  use_price = days * 30000;
                } else {
                  use_price =
                    (item.origin_price / item.total_count) * item.use_count;
                }

                // 잔여일차감금액
                let left_price = 0;
                if (restCoupon > restDate) {
                  left_price =
                    (restCoupon - restDate) *
                    (item.origin_price / item.total_count);
                } else {
                  left_price = 0;
                }

                let final_price =
                  item.total_price - commission - use_price - left_price;
                if (final_price < 0) {
                  final_price = 0;
                }

                return coupon === item.seq ? (
                  <Box key={index}>
                    <Box
                      sx={{
                        fontWeight: "bold",
                        mt: 2,
                      }}
                    >
                      환불 사유
                    </Box>
                    <TextField
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                      type="text"
                      size="small"
                      placeholder="사유를 적어주세요."
                      multiline
                      maxRows={4}
                      sx={{ width: "100%", marginTop: "12px" }}
                    />
                    <Box
                      sx={{
                        fontWeight: "bold",
                        mt: 2,
                      }}
                    >
                      쿠폰 정보
                    </Box>
                    <Table size="small" sx={{ width: "100%" }}>
                      <ThemeProvider theme={cellTheme}>
                        <TableBody>
                          <TableRow>
                            <TableCell>만료일</TableCell>
                            <TableCell align="right">
                              {item.edate} (잔여일 : {restDate}일)
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableBody>
                          <TableRow>
                            <TableCell>결제금액</TableCell>
                            <TableCell align="right">
                              {add_comma(item.total_price)}원
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        {item.is_seaason === "Y" ? (
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                차감금액 I ({add_comma(days)}일)
                              </TableCell>
                              <TableCell align="right">
                                {use_price > 0 ? "-" : ""}
                                {add_comma(use_price)}원
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        ) : (
                          <>
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  차감금액 I ({add_comma(item.use_count)}장)
                                </TableCell>
                                <TableCell align="right">
                                  {use_price > 0 ? "-" : ""}
                                  {add_comma(use_price)}원
                                </TableCell>
                              </TableRow>
                            </TableBody>
                            <TableBody>
                              <TableRow>
                                <TableCell>
                                  차감금액 II (
                                  {restCoupon > restDate
                                    ? add_comma(restCoupon - restDate)
                                    : 0}
                                  장)
                                </TableCell>
                                <TableCell align="right">
                                  {left_price > 0 ? "-" : ""}
                                  {add_comma(left_price)}원
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </>
                        )}
                        <TableBody>
                          <TableRow>
                            <TableCell>수수료</TableCell>
                            <TableCell align="right" sx={{ color: "blue" }}>
                              {commission > 0 ? "-" : ""}
                              {add_comma(commission)}원
                            </TableCell>
                          </TableRow>
                        </TableBody>
                        <TableBody>
                          <TableRow sx={{ background: "#f5f5f5" }}>
                            <TableCell>예상 환급 금액</TableCell>
                            <TableCell
                              align="right"
                              sx={{ fontWeight: "bold" }}
                            >
                              {add_comma(final_price)}원
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </ThemeProvider>
                    </Table>
                  </Box>
                ) : null;
              })}
            </Box>

            <Box sx={{ width: "100%", height: "100px" }}></Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              position: "fixed",
              bottom: "0",
              background: "white",
            }}
          >
            <Button
              variant="contained"
              sx={{
                width: "100%",
                marginBottom: "20px",
                marginTop: "10px",
                borderRadius: "0",
                background: "#0092a2",
                ":hover": {
                  background: "#0092a2",
                },
              }}
              onClick={onSubmit}
            >
              환불 신청
            </Button>
          </Box>
        </Dialog>
        <ListItem sx={{ textAlign: "center" }} onClick={openClick}>
          <ListItemAvatar>
            <RefundIcon width="24px" height="24px" />
          </ListItemAvatar>
          <ListItemText sx={{ textAlign: "left" }}>환불 신청</ListItemText>
          <ListItemAvatar>
            <ArrowRightIcon />
          </ListItemAvatar>
        </ListItem>
      </>
      {/* ) : (
                <Loading />
            )} */}
    </Box>
  );
}

export default Refund;
